export default "__VITE_ASSET__DqHq2Spp__"